/* @flow */
/* eslint-disable */
import React, { Component } from 'react';
import { reduxConnect } from '../../../../hoc';
import * as actions from '../../../../containers/Alerts/AlertTypes/actions.landmarks';
import SpeedThresholdAlert from '../../../../components/Alerts/AlertTypes/SpeedThreshold/SpeedThresholdAlert';

type Props = {
    landmarkGroups: Array<{}>,
    landmarkList: Array<{}>,
    fetchAlertCreationLandmarkGroupsList: Function,
    fetchLandmarkList: Function,
    formData:{
        config:{
            speedThresholdMPH: Number,
            selectedLandmarkGroups: Array<{}>,
            selectedLandmarkFilters: Array<{}>,
        },
    },
    handleTextboxChange: Function,
    handleCheckboxChange: Function,
    clearLandmarkSelects: Function,
    isLoading: boolean,
    validationError?: String,
};

type State = {
    allLandmarkGroups: Array<{}>,
    selectedLandmarkGroups: Array<{}>,
    selectedLandmarkFilters: Array<{}>,
};

class SpeedThresholdAlertList extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            allLandmarkGroups: [],
            selectedLandmarkGroups: this.props.formData.config.selectedLandmarkGroups,
            selectedLandmarkFilters: this.props.formData.config.selectedLandmarkFilters,
        };
    }

    // Fetching all landmark-groups/landmarks
    UNSAFE_componentWillMount() {
        this.props.fetchAlertCreationLandmarkGroupsList();
        const selectedLandmarkGroups = {
            selectedLandmarkGroups: this.props.formData.config.selectedLandmarkGroups ?
                this.props.formData.config.selectedLandmarkGroups : [],
        };
    }

    UNSAFE_componentWillReceiveProps(nextprops) {
        const { landmarkGroups, landmarkList } = nextprops;
        if (landmarkGroups && landmarkGroups.length > 0 &&
            this.state.allLandmarkGroups !== landmarkGroups) {
            this.setState({
                allLandmarkGroups: landmarkGroups,
            });
        }
    }
    // fetching landmarks from landmark-groups
    fetchLandmarksFromGroups = (landmarkGroupsList) => {
        const selectedLandmarkGroups = { selectedLandmarkGroups: [] };
        if (landmarkGroupsList.length > 0) {
            selectedLandmarkGroups.selectedLandmarkGroups = landmarkGroupsList;
        } else {
            selectedLandmarkGroups.selectedLandmarkGroups = [];
        }
    }

    render() {
        return (
            <SpeedThresholdAlert
                formData={this.props.formData}
                handleTextboxChange={this.props.handleTextboxChange}
                validationError={this.props.validationError}
                handleCheckboxChange={this.props.handleCheckboxChange}
                clearLandmarkSelects={this.props.clearLandmarkSelects}
                allLandmarkGroups={this.state.allLandmarkGroups}
            />
        );
    }
}

const mapStateToProps = state => ({
    landmarkGroups: state.alertLandmarks.landmarkGroups,
    isLoading: state.alertLandmarks.isLoading,
});

export default reduxConnect(SpeedThresholdAlertList, actions, mapStateToProps);
